import BaseController from "../sharedControllers/BaseController";
import { Routes } from "akademika/akamont/constants/Routes";
import { SpecificationWorkOrderListFilters } from "../../models/SpecificationWorkOrderListFilters";
import { Specification } from "../../models/Specification";
import HBox from "sap/m/HBox";
import Text from "sap/m/Text";

/**
 * @namespace akademika.akamont.pages.specificationToPdf
 */
export default class SpecificationToPdf extends BaseController {
  route = Routes.SPECIFICATION_TO_PDF;
  parentRoute = Routes.SPECIFICATION_DETAILS;

  public async onRouteMatched() {
    const specification = await this.fetchModel<Specification>(
      "api/Specification/GetSpecificationDetails/" +
      this.routeParams.specificationId
    );

    await this.getWorkOrders(specification);
  }

  public async getWorkOrders(specification: Specification) {
    const filterData: SpecificationWorkOrderListFilters = {
      specificationId: this.routeParams.specificationId,
      plannedDate: specification.date,
      partnerId: specification.partnerId,
      documentNumber: undefined,
    };

    const workOrdersListResponse = await this.post<Record<string, unknown>[]>(
      "api/Specification/GetWorkOrders",
      {
        body: filterData,
      }
    );

    const exitingWrokOrderIds = workOrdersListResponse.map(
      (wo) => wo["workOrderId"]
    );
    specification.workOrderIds =
      specification.workOrderIds?.filter((woId) =>
        exitingWrokOrderIds.includes(woId)
      ) || [];

    specification.totalAmount = 0;
    workOrdersListResponse.forEach((wo) => {
      if (
        wo["workOrderId"] &&
        specification.workOrderIds?.includes(wo["workOrderId"] as number)
      ) {
        wo["selected"] = true;
        specification.totalAmount =
          (specification.totalAmount || 0) + ((wo["amount"] as number) || 0);
      } else {
        wo["selected"] = false;
      }
    });

    const model = this.getModel();
    model.setData(specification);
    model.setProperty("/workOrders", workOrdersListResponse.filter(wo => wo["selected"]));

    this.renderMainContractsList();
  }

  public renderMainContractsList() {
    const mainContractList = this.getView()?.byId("mainContractList") as HBox;

    const workOrderContracts =
      (this.getModel().getProperty("/workOrders") as Record<string, unknown>[])
        ?.map(woc => woc.mainContractNumber as string)
        ?.filter(Boolean) ?? [];

    if (mainContractList) {
      mainContractList.removeAllItems();

      const validContracts = [...new Set(workOrderContracts)];

      validContracts.forEach((woc: string, index: number) => {
        const text = index < validContracts.length - 1 ? `${woc},\u00A0` : woc;

        mainContractList.insertItem(
          new Text({
            text: text
          }),
          index
        );
      });
    }
  }

  public backToDetails() {
    const id = this.routeParams.specificationId;
    this.navTo(this.parentRoute, { id });
  }
}
